import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { TrendingUp, TrendingDown, BarChart3 } from 'lucide-react';

interface CompareResultsProps {
  currentJobId: string;
  disabled?: boolean;
}

export const CompareResults: React.FC<CompareResultsProps> = ({ currentJobId, disabled }) => {
  return (
    <div className="space-y-4">
      <div className="text-white">
        <h3 className="font-medium mb-2">Compare Results</h3>
        <p className="text-slate-400 text-sm mb-4">
          Compare this ranking with previous runs to track improvements and insights.
        </p>
      </div>
      
      <div className="space-y-3">
        <div className="border border-slate-600 rounded-lg p-4 bg-slate-800">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-300 text-sm">Current Job</span>
            <Badge variant="outline" className="text-blue-400 border-blue-400">
              Active
            </Badge>
          </div>
          <div className="text-white font-medium">{currentJobId}</div>
        </div>
        
        <div className="border border-slate-600 rounded-lg p-4 bg-slate-800 opacity-50">
          <div className="flex items-center justify-between mb-2">
            <span className="text-slate-300 text-sm">Previous Job</span>
            <Badge variant="outline" className="text-slate-400 border-slate-400">
              Completed
            </Badge>
          </div>
          <div className="text-slate-400">job_prev_456</div>
          <div className="flex items-center gap-2 mt-2 text-sm">
            <TrendingUp className="w-4 h-4 text-green-400" />
            <span className="text-green-400">+12% accuracy</span>
          </div>
        </div>
        
        <Button 
          variant="outline" 
          className="w-full justify-start"
          disabled={disabled}
        >
          <BarChart3 className="w-4 h-4 mr-2" />
          View Comparison Report
        </Button>
      </div>
      
      {disabled && (
        <p className="text-slate-500 text-sm">
          Complete the job to enable comparisons
        </p>
      )}
    </div>
  );
}; 